/**
 * Normalizes API item shape to table row shape with stable id and estimatedFreightCost.
 * @param {Array<Object>} items - Raw items from packaging PO detail API.
 * @returns {Array<Object>} Normalized rows.
 */
export function normalizePackagingItems(items) {
    if (!Array.isArray(items)) return [];

    return items.map((item) => {
        const id = item?.poMapID ?? item?.poMapId ?? item?.id ?? null;
        return {
            ...item,
            id,
            packagingModelId: item?.packagingModelId ?? item?.packagingId ?? null,
            masterSku: item?.masterSku ?? item?.sku ?? null,
            description: item?.description ?? item?.itemName ?? null,
            unitsPerCase: item?.unitsPerCase ?? null,
            numPallets: item?.numPallets ?? null,
            qty: item?.qty ?? null,
            unitPrice: item?.unitPrice ?? null,
            vendorSku: item?.vendorSku ?? null,
            notes: item?.notes ?? '',
        };
    });
}
